/* eslint-disable no-unused-vars */
"use client";
import { Images } from "@assets/assets";
import Image, { StaticImageData } from "next/image";

export type HeaderConfig = {
  title: React.ReactNode;
  subtitle: string;
  description: string;
  buttonText?: string;
  mode?: "dark" | "light" | string;
  layoutVariant?: 1 | 2;
};

export type IndustryBenifitsProps = {
  header: HeaderConfig;
  ctaButton: React.ReactNode;
};

export default function IndustryBenifitsHeaderSection({
  header,
  ctaButton,
}: IndustryBenifitsProps) {
  return (
    <>
      <div className="texture-bg mix-blend-overlay  w-full h-full absolute top-0 left-0 z-0">
        <div
          className="absolute inset-0 z-0 opacity-60 pointer-events-none"
          style={{
            backgroundImage: `url(${Images.texture})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            mixBlendMode: "overlay",
          }}
        />
      </div>
      <div className="w-[907.05px] h-[907.05px] bg-[#225bd4]/40 rounded-full blur-[333.68px] absolute right-0 top-0 transform translate-x-1/3 -translate-y-1/3" />
      <div className="w-[907.05px] h-[907.05px] bg-[#225bd4]/40 rounded-full blur-[333.68px] absolute left-0 bottom-0 -translate-x-1/3 translate-y-1/3" />

      <div className="max-w-[2500px] mx-auto w-[calc(100%_-_10%)] pt-[30px] lg:pt-[150px] pb-[10px] lg:pb-[50px] relative z-1">
        <p className="self-stretch justify-center text-[#636363] text-base font-medium uppercase tracking-tight mb-5 lg:pb-0 pb-4">
          {header.subtitle}
        </p>
        <div className="technology-header gap-[15px] w-full lg:w-auto">
          <div
            className={`technology-header-left justify-between w-full flex flex-col lg:w-auto leading-[110%] ${
              header.layoutVariant === 2
                ? "lg:flex-col lg:items-start lg:gap-6"
                : "lg:flex-row lg:gap-6"
            }`}
          >
            <h2 className="self-stretch justify-start text-[length:var(--section-title)] font-medium clash-font min-w-[14ch]">
              <span className="text-[#FFF] capitalize leading-[110%]">
                {header.title}
              </span>
            </h2>
            <div
              className={`w-full justify-start lg:mt-0 text-[#949596] text-[length:var(--hero-para)] font-light leading-[150%] mb-5 ${
                header.layoutVariant === 2 ? "max-w-[80ch]" : "max-w-[50ch]"
              }`}
            >
              <div
                dangerouslySetInnerHTML={{ __html: header.description ?? "" }}
              />

              <div className="technology-header-right mt-5 flex justify-start">
                {ctaButton}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
